// extracted by mini-css-extract-plugin
module.exports = {"giftcard-transaction-table":"giftcard-transaction-table___1v7d3"};